<template>
  <div
    class="w-full rounded px-4 py-3 flex items-center justify-between bg-truegray-100 text-truegray-500 cursor-pointer z-20"
    :class="wrapperClasses"
    @click="showModalInputDropdownSelector"
  >
    <p class="text-xs text-truegray-500 m-0">
      {{ selectedOptionText }}
    </p>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus'
import { defineComponent, computed, ref, onMounted } from 'vue'
import { useStore } from '../../../js/store/index.js'
import { EVENT_KEYS, CD_STAT_TYPE_OPTIONS } from '../../../js/util/constants.js'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default defineComponent({
  name: 'InputDropdownSelector',

  props: {
    type: {
      type: String,
      required: true,
    },

    wrapperClasses: {
      type: String,
      default: '',
    },

    modalAction: {
      type: String,
      default: 'showModal',
    },
  },

  setup(props) {
    const store = useStore()

    const TYPE = props.type
    const MODAL_ACTION = props.modalAction
    const DROPDOWN_OPTIONS = CD_STAT_TYPE_OPTIONS[TYPE].OPTIONS(store)

    const selectedOption = ref(DROPDOWN_OPTIONS[0].value)
    const selectedOptionText = computed(() => {
      return DROPDOWN_OPTIONS.find((opt) => opt.value === selectedOption.value)
        ?.text
    })

    const showModalInputDropdownSelector = () => {
      EventBus.$emit(MODAL_ACTION, {
        action: 'CWContributorInputDropdownSelector',
        data: {
          dynamicWidth: true,
          type: TYPE,
          options: DROPDOWN_OPTIONS,
          selectedOption: selectedOption.value,
        },
      })
    }

    onMounted(() => {
      EventBus.$on(EVENT_KEYS.CD_INPUT_DROPDOWN_UPDATED, (config) => {
        if (config.type === TYPE) {
          selectedOption.value = config.value || 0
          EventBus.$emit(MODAL_ACTION, false)
        }
      })
    })

    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      selectedOptionText,
      showModalInputDropdownSelector,
    }
  },
})
</script>
